<template>
  <div class="capacity-section">
    
  </div>
</template>

<script>
export default {
  name: "CapacitySection",
};
</script>

<style scoped lang="scss">

</style>